import { Section } from './section';

// stays
import { Stays } from 'pages/stays/grid/index';
import { StayCard } from 'pages/stays/card/stay-card';
// clients
import { Clients } from 'pages/clients/grid/index';
import { ClientCard } from 'pages/clients/card/client-card';
import { ClientAddCard } from 'pages/clients/card/client-add-card';
// payments
import { RfidWrapper } from 'pages/payments/rfid/rfid';
import { EpmWrapper } from 'pages/payments/epm/epm';
import { PlateWrapper } from 'pages/payments/plate/plate';
import { SubscriptionWrapper } from 'pages/payments/subscription/subscription';
import { GreyPlateWrapper } from 'pages/payments/grey-plate/grey-plate';
// reports
import { RideWrapper } from 'pages/reports/ride/ride';
import { PlateRideWrapper } from 'pages/reports/plate-ride/plate-ride';
import CashboxOperations from 'pages/reports/cashbox';
import Calls from 'pages/reports/calls';
import Events from 'pages/reports/events';
import { ActionWrapper } from 'pages/reports/actions';
import AdditionalReports from 'pages/reports/additionalReports';
import { Summary } from 'pages/reports/summary/summary';
import Benefits from 'pages/reports/benefits';
import Promises from 'pages/reports/promises';
import Discounts from 'pages/reports/discounts';
import Rollback from 'pages/reports/refund';
// options
import Tariffs from 'pages/options/tariffs/grid';
import { TariffCard } from 'pages/options/tariffs/card/tariff-card';
import { NewTariffCard } from 'pages/options/tariffs/card/tariff-card-new';
import { Rules } from 'pages/options/rules';
import { RoleWrapper } from 'pages/options/roles/roles';
import Users from 'pages/options/users';
import { CategoryWrapper } from 'pages/options/categories';
import { CollectionWrapper } from 'pages/options/collection';
import { Parkings } from 'pages/options/parkings/parkings';
import { BenefitTypeWrapper } from 'pages/options/benefits-types';
import OptAdv from 'pages/options/adv';
import SOUpload from 'pages/options/soupload/soupload';
// other
import { Empty } from 'pages/empty/empty';
import { Test } from 'pages/test/test';

export const components = {
  test: Test,
  empty: Empty,
  scheme: null,
  section: Section,
  stays: Stays,
  stay: StayCard,
  clients: Clients,
  add_client: ClientAddCard,
  client: ClientCard,
  rfid: RfidWrapper,
  epm: EpmWrapper,
  plate: PlateWrapper,
  subscription: SubscriptionWrapper,
  grey_plate: GreyPlateWrapper,
  rides: RideWrapper,
  plate_rides: PlateRideWrapper,
  cashbox_operations: CashboxOperations,
  calls: Calls,
  events: Events,
  actions: ActionWrapper,
  summary: Summary,
  benefits: Benefits,
  discounts: Discounts,
  promises: Promises,
  additional: AdditionalReports,
  refund: Rollback,
  tariffs: Tariffs,
  tariff: TariffCard,
  new_tariff: NewTariffCard,
  rules: Rules,
  users: Users,
  collection: CollectionWrapper,
  roles: RoleWrapper,
  categories: CategoryWrapper,
  benefit_types: BenefitTypeWrapper,
  parkings: Parkings,
  optadv: OptAdv,
  soupload: SOUpload,
};
